import { connect } from 'react-redux';

import { IApplicationState } from '@store';
import {
  cancelUpload,
  removeUpload,
  selectExperimentsFile,
  validateExperimentList,
  discardExperimentsList,
  startUpload,
  getUploads,
} from '@store/actions';

import { IUpload } from '@models';

import Upload, {
  IUploadStateProps,
  IUploadDispatchProps,
} from '../components/upload/Upload';
interface IStateToProps
  extends Pick<IApplicationState, 'uploads' | 'experimentLists'> {}

const mapStateToProps = ({
  uploads,
  experimentLists,
}: IStateToProps): IUploadStateProps => ({
  experimentLists: experimentLists.experimentLists,
  uploads: uploads.uploads,
  uploadStatus: uploads.status,
});

const mapDispatchToProps = (dispatch: any): IUploadDispatchProps => ({
  getUploads: () => dispatch(getUploads()),
  experimentListSelected: (id: string, file: File) =>
    dispatch(selectExperimentsFile(id, file)),
  cancel: (upload: IUpload) => dispatch(cancelUpload(upload)),
  remove: (upload: IUpload) => dispatch(removeUpload(upload)),
  validateExperimentsList: (id: string) => dispatch(validateExperimentList(id)),
  discardExperimentList: (id: string) => dispatch(discardExperimentsList(id)),
  startUpload: (id: string) => dispatch(startUpload(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Upload);
